import { MutationTree } from 'vuex'
import { Notifications, NotificationsState } from './types'

export enum NotificationsMutations {
  SET_LOADER = 'SET_LOADER',
  SET_LOADER_INFO = 'SET_LOADER_INFO',
  SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
}

export const mutations: MutationTree<NotificationsState> = {
  [NotificationsMutations.SET_LOADER](
    state: NotificationsState,
    payload: boolean
  ) {
    state.loading = payload
  },

  [NotificationsMutations.SET_LOADER_INFO](
    state: NotificationsState,
    payload: boolean
  ) {
    state.loadingInfo = payload
  },

  [NotificationsMutations.SET_NOTIFICATIONS](
    state: NotificationsState,
    payload: Notifications
  ) {
    state.notifications = payload
  }
}
